type MenuIconProps = {
  height?: number | string;
  width?: number | string;
  color?: string;
};

const MenuIcon: React.FC<MenuIconProps> = ({ height = '24', width = '25' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.19922 6H20.1992H4.19922ZM4.19922 12H20.1992H4.19922ZM4.19922 18H20.1992H4.19922Z"
      fill={'currentColor'}
    />
    <path
      d="M4.19922 18H20.1992M4.19922 6H20.1992H4.19922ZM4.19922 12H20.1992H4.19922Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);

export default MenuIcon;
